export const INCREMENT_PRICE_LEVEL = "INCREMENT_PRICE_LEVEL";
export const DECREMENT_PRICE_LEVEL = "DECREMENT_PRICE_LEVEL";
export const SET_PRICE_LEVEL = "SET_PRICE_LEVEL";
export const SET_NEW_QUANTITIES = "SET_NEW_QUANTITIES";
export const CLEAR_SELECTED_PRICE_LEVELS = "CLEAR_SELECTED_PRICE_LEVELS";
export const SET_DISPLAY_CONFIGURATION_ERROR = "SET_DISPLAY_CONFIGURATION_ERROR";

export function incrementPriceLevel(id) {
    return (dispatch, getState) => {
        let state = getState();
        let level = state.priceLevel.levels[id];
        let quantity = state.ticketPicker.quantities[id];

        if(quantity === +level.transaction_limit) {
            return;
        }

        dispatch({type: INCREMENT_PRICE_LEVEL, id});
    }
}

export function decrementPriceLevel(id) {
    return {type: DECREMENT_PRICE_LEVEL, id};
}

export function setPriceLevel(id, value) {
    return {type: SET_PRICE_LEVEL, id, value};
}

export function setPriceLevelsQuantities(quantities) {
    return {type: SET_NEW_QUANTITIES, quantities};
}

export function clearSelectedPriceLevels() {
    return {type: CLEAR_SELECTED_PRICE_LEVELS};
}

export function setDisplayConfigurationError(value) {
    return {type: SET_DISPLAY_CONFIGURATION_ERROR, value};
}
